import React from "react";

import { Badge, Col, Container, Row } from "reactstrap";

import { Parallax } from "react-parallax";
import JumboCarousel from "./JumboCarousel";
import TestimonialCarousel from "./TestimonialCarousel";
import ShowcaseCard from "./ShowcaseCard";
import TeacherCard from "./TeacherCard";
import ProgramsCarousel from "./ProgramsCarousel";
import { useChannelIOApi, useChannelIOEvent } from "react-channel-plugin";

const Landing = () => {
  const { showMessenger } = useChannelIOApi();

  useChannelIOEvent("onShowMessenger", () => {
    console.log("Messenger opened!");
  });

  const name = "1:1 Online A-Level";
  const buttonText = "자세히";
  const topPrograms = [
    {
      title: "데이터 사이언티스트가 되고 싶다면?",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      tags: ["# Maths", "# Statistics", "# Big Data"],
      buttonText: buttonText,
      img: "maths.png",
      targetPath: "/page/career/data_scientist",
    },
    {
      title: "경제 상식은 요즘 필수",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Economics", "# Business", "# Finance"],
      buttonText: buttonText,
      img: "money.png",
      targetPath: "/page/career/economics",
    },
    {
      title: "제 2의 일론 머스크를 꿈 꾼다면?",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Physics", "# Mechanics", "# Engineering"],
      buttonText: buttonText,
      img: "elon_musk.png",
      targetPath: "/page/career/elon_musk",
    },
    {
      title: "의대 / 치대를 위한 학생",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Medicine", "# Biology", "# Chemistry"],
      buttonText: buttonText,
      img: "card2.png",
      targetPath: "/page/career/doctor",
    },
    {
      title: "화장품 / 향수는 어떻게 만들어질까?",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Chemistry", "# Cosmetics", "# fragrance"],
      buttonText: buttonText,
      img: "cosmetics3.png",
      targetPath: "/page/career/cosmetic_create",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/page/career/blockchain",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
    {
      title: "NFT, 블록체인이 궁금하다면!",
      name: name,
      description:
        "수학자를 꿈꾸는 학생이나 수학을 집중적으로 공부하고 싶은 학생을 위한 학습 순서입니다.",
      labels: ["특별 할인", "7월 강의"],
      tags: ["# Computer Science", "# NFT", "# Coding"],
      buttonText: buttonText,
      img: "ethereum.png",
      targetPath: "/career",
    },
  ];

  return (
    <React.Fragment>
      <JumboCarousel />

      <div id="popularPrograms" className="site-section">
        <Container className="pl-5 pr-5">
          <Row className="mb-3">
            <Col md={8}>
              <h2 className="heading landing-title">
                이번달 인기 프로그램{" "}
                <Badge className="title-badge" color="info">
                  TOP
                </Badge>
              </h2>
              <h2 className="heading section-title">
                내게 딱 맞는 학습 순서가 궁금하다면?{" "}
              </h2>
              <span className="subheading">원하는 분야를 선택해보세요!</span>
            </Col>
          </Row>

          <ProgramsCarousel topPrograms={topPrograms} />

          <hr className="mt-4 mb-4" />

          <Row className="mb-3">
            <Col md={8}>
              <h2 className="heading section-title">
                이 달의 선생님{" "}
                <Badge className="title-badge" color="danger">
                  인기
                </Badge>
              </h2>
            </Col>
          </Row>
          <Row className="landing-second">
            <Col md={3} className="mb-4">
              <TeacherCard
                title="UCL Computer Science"
                name="Jerry"
                description="국회는 국무총리 또는 국무위원의 해임을 대통령에게 건의할 수 있다.
          국가는 건전한 소비행위를 계도하고 생산품의 품질향상을 촉구하기 위한
          소비자보호운동을 법률이 정하는 바에 의하여 보장한다, 학교교육 및
          평생교육을 포함한 교육제도와 그 운영."
                labels={["문제풀이 위주", "설명왕", "스파르타식"]}
                tags={["IB", "온라인 강의", "해외명문대 진학"]}
                buttonText="사전예약"
                img="jerry.png"
                targetPath="/page/class/alevel"
              />
            </Col>
            <Col md={3} className="mb-4">
              <TeacherCard
                title="LSE 경재학과"
                name="Owen"
                description="국회는 국무총리 또는 국무위원의 해임을 대통령에게 건의할 수 있다.
          국가는 건전한 소비행위를 계도하고 생산품의 품질향상을 촉구하기 위한
          소비자보호운동을 법률이 정하는 바에 의하여 보장한다, 학교교육 및
          평생교육을 포함한 교육제도와 그 운영."
                labels={["문제풀이 위주", "설명왕", "스파르타식"]}
                tags={["IELTS", "온라인 강의", "해외명문대 진학"]}
                buttonText="사전예약"
                img="owen.png"
                targetPath="/page/class/alevel"
              />
            </Col>
            <Col md={3}>
              <TeacherCard
                title="Imperial College 수학과"
                name="Senny"
                description="국회는 국무총리 또는 국무위원의 해임을 대통령에게 건의할 수 있다.
          국가는 건전한 소비행위를 계도하고 생산품의 품질향상을 촉구하기 위한
          소비자보호운동을 법률이 정하는 바에 의하여 보장한다, 학교교육 및
          평생교육을 포함한 교육제도와 그 운영."
                labels={["문제풀이 위주", "설명왕", "스파르타식"]}
                tags={["A-Level", "온라인 강의", "해외명문대 진학"]}
                buttonText="사전예약"
                img="senny.png"
                targetPath="/page/class/alevel"
              />
            </Col>
            <Col md={3}>
              <TeacherCard
                title="UCL Psychology"
                name="Alice"
                description="국회는 국무총리 또는 국무위원의 해임을 대통령에게 건의할 수 있다.
          국가는 건전한 소비행위를 계도하고 생산품의 품질향상을 촉구하기 위한
          소비자보호운동을 법률이 정하는 바에 의하여 보장한다, 학교교육 및
          평생교육을 포함한 교육제도와 그 운영."
                labels={["문제풀이 위주", "설명왕", "스파르타식"]}
                tags={["A-Level", "온라인 강의", "해외명문대 진학"]}
                buttonText="사전예약"
                img="alice.png"
                targetPath="/page/class/alevel"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div id="section2" className="site-section">
        <Parallax
          blur={0}
          bgImage={require("../../assets/img/parallax2.jpg")}
          bgImageAlt="parallax"
          strength={1000}
          bgImageStyle={{ height: "140%", width: "100%" }}
        >
          <div style={{ height: "50%" }} />
          <div className="pt-5 pb-3 mt-3 mb-3 align-items-center justify-content-center text-center">
            <h2 className="para-heading">" OVER THE MOON, OVER THE WORLD "</h2>
          </div>
          <TestimonialCarousel />
          <div style={{ height: "25vh" }} />
        </Parallax>
        <div className="main-banner">
          <div className="bg-img-covid-responsive"></div>
        </div>
      </div>
      {/* <button onClick={showMessenger}>
        <span>Open</span>
      </button> */}
    </React.Fragment>
  );
};

export default Landing;
